import * as API from '@/services/API';

export default {
  get(id) {
    return API.apiClient.get(`/organisation-types/${id}`);
  },
  list(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/organisation-types/${query}`);
  },
  async delete(id) {
    return API.apiClient.delete(`/organisation-types/${id}`);
  },
  paginate(link) {
    return API.apiClient.get(link);
  },
  async save(id, data) {
    if (id == 0) {
      return API.apiClient.post(`/organisation-types`, data);
    } else {
      return API.apiClient.put(`/organisation-types/${id}`, data);
    }
  },
  search(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/organisation-types/search${query}`);
  }
};
